export const primaryColor = "#224b96ff";
export const secondaryColor = "#2767eb";
export const primaryDarkColor = "#1a1c50ff";
export const secondaryDarkColor = "#30567aff";
export const colorOverBody = "black";